import React, { useState } from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import './Admin.scss';
import Logout from '../../components/Logout/Logout';
import Icon from '../../components/Icon/Icon';

const LayoutAdmin = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    const navItems = [
        { path: '/admin', label: 'Home', icon: 'house' },
        { path: '/admin/dashboards', label: 'Dashboards', icon: 'dashboard-admin', color: '#000' },
        { path: '/admin/users', label: 'Users', icon: 'person' },
        { path: '/admin/creation', label: 'Creations', icon: 'creation-admin' },
        { path: '/admin/news', label: 'News', icon: 'news' },
        { path: '/admin/new', label: 'New', icon: 'creation-admin' },
        { path: '/admin/paiements', label: 'Payments', icon: 'paymen-admin' },
        { path: '/admin/invite', label: 'Invite', icon: 'mail' },
    ];

    // Check if current path is a dashboard route
    const isDashboardRoute = location.pathname.startsWith('/admin/dashboards');
    const isHomeRoute = location.pathname === '/admin';

    const handleMobileMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleNavLinkClick = () => {
        // Close mobile menu when a navigation link is clicked
        setIsMobileMenuOpen(false);
    };

    return (
        <div className="admin-layout admin-container">
            {/* Mobile menu toggle button */}
            <button 
                className="mobile-menu-toggle"
                onClick={handleMobileMenuToggle}
                aria-label="Toggle mobile menu"
            >
                <Icon alias="menu" color="#ffffff" width={24} />
            </button>

            {/* Mobile overlay */}
            <div 
                className={`nav-overlay ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={handleMobileMenuToggle}
            />

            <nav className={`nav-admin ${isSidebarCollapsed ? 'collapsed' : ''} ${isMobileMenuOpen ? 'mobile-open' : ''}`} aria-label="Admin navigation">
                <div className="nav-header">
                    <div className='admin-logo'><Icon  alias="hyk-logo-admin" color="#FF3232" height={ isSidebarCollapsed ? 18 : 22} width={ isSidebarCollapsed ? 48 : 68} />
                    <div className='admin-label'>Admin</div></div>
                    <button 
                        className="collapse-btn"
                        onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                    >
                        <Icon alias={isSidebarCollapsed ? 'chevron-right' : 'chevron-left'} color="#282828" width={20} strokeWidth={5} />
                    </button>
                </div>
                <div className="nav-links">
                    {navItems.map((item) => {
                        const isActive =
                            location.pathname === item.path ||
                            (item.path === '/admin/dashboards' && isDashboardRoute) ||
                            (item.path === '/admin/creation' && location.pathname.startsWith('/admin/creation')) ||
                            (item.path === '/admin/news' && location.pathname.startsWith('/admin/news'));
                        return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`nav-link ${isActive ? 'active' : ''}`}
                            aria-current={isActive ? 'page' : undefined}
                            onClick={handleNavLinkClick}
                        >
                            <Icon alias={item.icon} color="#282828"  width={20} />
                            {!isSidebarCollapsed && <span>{item.label}</span>}
                        </Link>
                        );
                    })}
                    <Logout classNames="nav-link logout" onClick={handleNavLinkClick}>
                        <Icon alias="logout" color="#282828" width={20} />
                        {!isSidebarCollapsed && <span>Logout</span>}
                    </Logout>
                </div>
            </nav>
            <main className={`admin-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                {!isDashboardRoute && !isHomeRoute && (
                    <div className="content-header">
                        <h1>{navItems.find(item => item.path === location.pathname || (item.path !== '/admin/dashboards' && item.path !== '/admin' && location.pathname.startsWith(item.path + '/')))?.label || 'Admin'}</h1>
                    </div>
                )}
                <div className="content-body">
                    <Outlet />
                </div>
            </main>
        </div>
    )
}

export default LayoutAdmin